// extracted by mini-css-extract-plugin
export default {"root":"C44EMe","galleryWrapper":"lslQSV","wixGalleryWrapper":"aQ0s77","fadeIn":"JUaYL9","changing_background":"guBhoB","changingBackground":"guBhoB"};